import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["wickSelect", "wickVariantSelect", "diameterInput"]
  static values = {
    wicks: Array,
    wickVariants: Array,
    variantId: String
  }

  connect() {
    console.log("Mold variant wick controller connected")

    // If there's a selected wick, populate the variants dropdown
    if (this.wickSelectTarget.value) {
      this.populateWickVariants(parseInt(this.wickSelectTarget.value))
    }
  }

  updateWickVariants(event) {
    let wickId

    // Check if event is from wick select or diameter input
    if (event.target === this.wickSelectTarget) {
      wickId = parseInt(event.target.value)
    } else {
      // It's from diameter input, use current wick select value
      wickId = parseInt(this.wickSelectTarget.value)
    }

    this.populateWickVariants(wickId)
  }

  populateWickVariants(wickId) {
    const wickVariantSelect = this.wickVariantSelectTarget
    const currentValue = wickVariantSelect.value

    // Clear current options
    wickVariantSelect.innerHTML = '<option value="">Select a wick first</option>'

    if (!wickId) {
      return
    }

    // Filter wick variants for selected wick
    const variants = this.wickVariantsValue.filter(wv => wv.wick_id === wickId)

    // Get diameter value if available (in cm, need to convert to mm)
    const diameterCm = this.hasDiameterInputTarget ? parseFloat(this.diameterInputTarget.value) : null
    const diameterMm = diameterCm ? diameterCm * 10 : null

    if (diameterMm && diameterMm > 0) {
      // Separate into recommended and other wicks based on diameter
      const recommended = []
      const others = []

      variants.forEach(wv => {
        if (wv.diameter_min && wv.diameter_max) {
          if (diameterMm >= wv.diameter_min && diameterMm <= wv.diameter_max) {
            recommended.push(wv)
          } else {
            others.push(wv)
          }
        } else {
          others.push(wv)
        }
      })

      // Add recommended wicks group
      if (recommended.length > 0) {
        const recommendedGroup = document.createElement('optgroup')
        recommendedGroup.label = 'Recommended for this diameter'
        recommended.forEach(wv => {
          const option = document.createElement('option')
          option.value = wv.id
          option.textContent = wv.display_name
          if (wv.id.toString() === currentValue) {
            option.selected = true
          }
          recommendedGroup.appendChild(option)
        })
        wickVariantSelect.appendChild(recommendedGroup)
      }

      // Add other wicks group
      if (others.length > 0) {
        const othersGroup = document.createElement('optgroup')
        othersGroup.label = 'Other wicks'
        others.forEach(wv => {
          const option = document.createElement('option')
          option.value = wv.id
          option.textContent = wv.display_name
          if (wv.id.toString() === currentValue) {
            option.selected = true
          }
          othersGroup.appendChild(option)
        })
        wickVariantSelect.appendChild(othersGroup)
      }
    } else {
      // No diameter, just list all variants
      variants.forEach(variant => {
        const option = document.createElement('option')
        option.value = variant.id
        option.textContent = variant.display_name
        // Restore the previously selected value if it exists
        if (variant.id.toString() === currentValue) {
          option.selected = true
        }
        wickVariantSelect.appendChild(option)
      })
    }
  }
}

